// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HistoryReadResponseMetaQuery
 */
export interface HistoryReadResponseMetaQuery {
    /**
     * Start of time range (echoed from request)
     */
    startTime: Date;
    /**
     * End of time range (echoed from request, resolved if omitted)
     */
    endTime: Date;
    /**
     * Maximum number of values per node (echoed from request)
     */
    numValuesPerNode?: number;
}

/**
 * Check if a given object implements the HistoryReadResponseMetaQuery interface.
 */
export function instanceOfHistoryReadResponseMetaQuery(value: object): value is HistoryReadResponseMetaQuery {
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    return true;
}

export function HistoryReadResponseMetaQueryFromJSON(json: any): HistoryReadResponseMetaQuery {
    return HistoryReadResponseMetaQueryFromJSONTyped(json, false);
}

export function HistoryReadResponseMetaQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryReadResponseMetaQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
        'numValuesPerNode': json['numValuesPerNode'] == null ? undefined : json['numValuesPerNode'],
    };
}

export function HistoryReadResponseMetaQueryToJSON(json: any): HistoryReadResponseMetaQuery {
    return HistoryReadResponseMetaQueryToJSONTyped(json, false);
}

export function HistoryReadResponseMetaQueryToJSONTyped(value?: HistoryReadResponseMetaQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'startTime': value['startTime'].toISOString(),
        'endTime': value['endTime'].toISOString(),
        'numValuesPerNode': value['numValuesPerNode'],
    };
}

